import React from "react";
import "./updateHome.css";

const guardians = [
  {
    id: "1",
    tittle: "Submit Your Tutor Request",
    icon: "https://i.ibb.co/q54x8hS/a-boy-is-using-a-laptop-removebg-preview.png",
    des: "Fill out all the required fields and submit your request.",
  },
  {
    id: "2",
    tittle: "Get the Maximum 5 Best Tutor CVs",
    icon: "https://i.ibb.co/g79rN7D/girl-searching-for-boy-account-removebg-preview.png",
    des: "Within 48 hours, you will get up to 5 CVs of the best tutors who applied to your posted job",
  },
  {
    id: "3",
    icon: "https://i.ibb.co/X7VzZF4/seo-ranking-removebg-preview.png",
    tittle: "Select the Best One & Start Learning",
    des: "Select a tutor from the shortlist and take trial classes to confirm your tutor.",
  },
];
const tutors = [
  {
    id: "1",
    tittle: "Create a Free Account",
    icon: "https://i.ibb.co/RSPNBsz/006-removebg-preview.png",
    des: "Create your account in minutes with some required information.",
  },
  {
    id: "2",
    tittle: "Complete Your Profile",
    icon: "https://i.ibb.co/WgXF4RB/a-guy-is-chatting-online-with-a-user-removebg-preview.png",
    des: "Complete your profile by including your personal, educational, tuition related and supporting documentation details.",
  },
  {
    id: "3",
    icon: "https://i.ibb.co/ZHC0KGH/2072076-removebg-preview.png",
    tittle: "Apply to Your Desired Tuition Job",
    des: "Get shortlisted from system and selected by the guardian/student based on your provided information in profile.",
  },
  {
    id: "4",
    icon: "https://i.ibb.co/ZTfgGB6/18cf6d51-3f85-445b-8bb1-02ea4c9fd8df-removebg-preview.png",
    tittle: "Start Tutoring",
    des: "Take the trial classes and confirm your expected tuition job. Happy tutoring!",
  },
];

const reviews = [
  {
    id: "1",
    name: "Md Sharif",
    uni: "Dhaka University",
    img: "https://example.com/john.jpg",
    review:
      "Tutor Find Students made it incredibly easy for me to connect with students in my area. The interface is user-friendly, and I have been able to increase my tutoring sessions significantly. Highly recommend!",
  },
  {
    id: "2",
    name: "Sabbir Islam",
    uni: "Chittagong University",
    img: "https://example.com/jane.jpg",
    review:
      "As a tutor, finding students was always a challenge until I started using this platform. The matching system is efficient, and I've had great experiences with my students so far. The support team is also very responsive.",
  },
  {
    id: "3",
    name: "Rafiq Haque",
    uni: "Brac University",
    img: "https://example.com/emily.jpg",
    review:
      "I love how easy it is to set up my profile and start receiving student inquiries. The site has a great layout and offers various tools to help me manage my tutoring schedule.",
  },
  {
    id: "4",
    name: "Touhidul Haque Uthso",
    uni: "Tongi Govt. College",
    img: "https://example.com/michael.jpg",
    review:
      "Tutor Find Students has expanded my reach beyond my local area, allowing me to offer online sessions to students nationwide. The platform is reliable and easy to use.",
  },
  {
    id: "5",
    name: "Sopnil Islam",
    uni: "Jagannath University",
    img: "https://example.com/sophia.jpg",
    review:
      "The platform is a game-changer for tutors. I've been able to connect with students who are genuinely interested in learning, and the feedback system helps me improve my tutoring skills.",
  },
  {
    id: "6",
    name: "Maruf Ahmed",
    uni: "Dhaka Medical College",
    img: "https://example.com/james.jpg",
    review:
      "Signing up for Tutor Find Students was one of the best decisions I've made. I've been able to fill my schedule with students who match my expertise perfectly. It's an essential tool for any tutor.",
  },
  {
    id: "7",
    name: "Rakib Islam",
    uni: "North South University",
    img: "https://example.com/olivia.jpg",
    review:
      "I've had a wonderful experience using this platform. The process of finding students is seamless, and the site provides all the necessary tools to ensure a successful tutoring session. I highly recommend it to fellow tutors.",
  },
];

const doubledReviews = [...reviews, ...reviews];
const HomeTutors = () => {
  return (
    <div className="w-[70%] mx-auto my-10">
      <h1 className="text-7xl font-signika text-black">
        What some Awesome <br></br> Guardian/Student Says about Us
      </h1>
      <div className="py-5 flex justify-center items-center flex-col ">
        <div className="w-full py-5 flex justify-start items-center overflow-hidden">
          <div className="flex flex-row animate-slide-reverse gap-20 ">
            {doubledReviews.map((data, index) => (
              
              <div className="">
              <div className="containerDetails z-0 relative card bg-green-700 w-[600px] flex-shrink-0 h-96  flex justify-center items-center p-10 ">
                <img
                  alt=""
                  className="w-36 absolute bottom-10 right-10 opacity-20"
                  src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgMTk4IDE5OCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PGc+PHBhdGggZD0iTTAgOTIuOTA1aDQ4LjAyNGMtLjgyMSAzNS0xMC43NDggMzguOTczLTIzLjIxNiA0MC4xMDdsLTQuODA4LjU5NnYzOC40ODZsNS41NDItLjI5N2MxNi4yODEtLjkxNiAzNC4yODEtMy44NTEgNDYuMjktMTguNjc2QzgyLjM1OSAxNDAuMTI1IDg3IDExOC44OTMgODcgODYuM1YyNS45MDVIMHY2N3pNMTExIDI1LjkwNXY2N2g0Ny4zODNjLS44MjEgMzUtMTAuNDI3IDM4Ljk3My0yMi44OTUgNDAuMTA3bC00LjQ4OC41OTZ2MzguNDg2bDUuMjIyLS4yOTdjMTYuMjgxLS45MTYgMzQuNDQyLTMuODUxIDQ2LjQ1MS0xOC42NzZDMTkzLjE5OSAxNDAuMTI1IDE5OCAxMTguODkzIDE5OCA4Ni4zVjI1LjkwNWgtODd6IiBmaWxsPSIjZmZmZmZmIiBvcGFjaXR5PSIxIiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIj48L3BhdGg+PC9nPjwvc3ZnPg=="
                />
                {/* Overlay */}
                <div className="overlay absolute top-0 left-0 w-full  bg-green-400 opacity-50"></div>

                {/* Text */}
                <div className=" flex flex-col justify-between text absolute top-0 left-0 p-10 z-10 text-white w-[100%] h-[100%]">
                <div className="flex justify-between flex-col h-full">
                  <div className="">
                    <h1 className=" text-white text-4xl font-bold  font-signika py-2">
                      {data.name}
                    </h1>
                    <h1 className=" text-white pb-2 font-signika text-2xl border-b border-b-green-200">
                      {data.uni}
                    </h1>
                    <h1 className="mt-5 text-red-200 break-words whitespace-normal text-start text-xl font-signika">
                    {data.review}
                  </h1>
                  </div>
                 
                </div>
                </div>
              </div>
            </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeTutors;
